import { BaseUrlsKey } from '../viewer-script/types';
import { EcomPlatformWidgetID } from '../constants';

export const CART_DSN =
  'https://7a9383877d1648169973b9d6339b753b@o37417.ingest.us.sentry.io/5552111';
export const CART_ICON_DSN =
  'https://a15b644ebf243f0edfda94c3b7cdaf66@o37417.ingest.us.sentry.io/4510261235482624';
export const THANK_YOU_PAGE_DSN =
  'https://5ce86095794d4b0dbded2351db71baf8@o37417.ingest.sentry.io/5792095';
export const ECOM_PLATFORM_CHECKOUT_DSN =
  'https://08dd4559406cdafb36366882e5cc6c35@o37417.ingest.us.sentry.io/4509991474888704';

interface SentryConf {
  dsn: string;
  baseUrlsKey?: BaseUrlsKey;
}

export const sentryConfPerController: Record<string, SentryConf> = {
  [EcomPlatformWidgetID.CART]: { dsn: CART_DSN, baseUrlsKey: 'cartBaseUrl' },
  [EcomPlatformWidgetID.CART_ICON]: {
    dsn: CART_ICON_DSN,
    baseUrlsKey: 'cartIconBaseUrl',
  },
  [EcomPlatformWidgetID.THANK_YOU_PAGE]: {
    dsn: THANK_YOU_PAGE_DSN,
    baseUrlsKey: 'thankYouPageBaseUrl',
  },
  [EcomPlatformWidgetID.ECOM_PLATFORM_CHECKOUT]: {
    dsn: ECOM_PLATFORM_CHECKOUT_DSN,
    baseUrlsKey: 'ecomPlatformCheckoutBaseUrl',
  },
};
